import axios from 'axios'
import {Form, Formik} from 'formik'
import moment from 'moment'
import {useState} from 'react'
import Select from 'react-select'
import {toast} from 'react-toastify'
import {Modal} from 'rsuite'
import FormDatepicker from 'src/cms/helpers/components/forms/FormDatepicker'
import FormTextBox from 'src/cms/helpers/components/forms/FormTextBox'
import * as Yup from 'yup'
const API_URL = window.__RUNTIME_CONFIG__.REACT_APP_API_URL

type Props = {
  selectedCandidate: any
  selectedSatusId?: any
  setShowInterviewVenuModal: any
  handleStatusUpdate: any
  setSelectedCandidate: any
}

const FORM_VALIDATION = Yup.object({
  venue: Yup.string().required('Venue is required'),
  date: Yup.string().required('Date is required'),
  time: Yup.string().required('Time is required'),
})

export default function ChooseInterviewVenu({
  selectedCandidate,
  setShowInterviewVenuModal,
  selectedSatusId,
  handleStatusUpdate,
  setSelectedCandidate,
}: Props) {
  const [loading, setLoading] = useState(false)

  const handleFormSubmit = (payload: any) => {
    setLoading(true)

    axios
      .post(`${API_URL}/apply-vacancy/update-interview-status`, payload)
      .then((res) => {
        const message = res.data.data
        setLoading(false)
        handleStatusUpdate(message)
        setShowInterviewVenuModal(false)
      })
      .catch((err) => {
        setLoading(false)
        toast.error(
          err?.response?.data?.message ? err.response.data.message : 'Something went wrong'
        )
      })
  }

  return (
    <Modal
      open={true}
      className='w-25'
      backdrop='static'
      keyboard={false}
      enforceFocus={false}
      onClose={() => {
        setShowInterviewVenuModal(false)
      }}
      data-cy='modal'
    >
      <Modal.Header>
        <Modal.Title data-cy='modal-title'>Assign Interview Venue </Modal.Title>
      </Modal.Header>
      <Modal.Body className='pb-0'>
        <Formik
          initialValues={{
            vacancyApplicantId: selectedCandidate || [],
            venue: '',
            date: '',
            time: '',
          }}
          validationSchema={FORM_VALIDATION}
          onSubmit={(values: any, {setSubmitting}) => {
            const payload = {
              vacancyApplicantStatus: values.vacancyApplicantId.map((item: any) => {
                return {vacancyApplicantId: item.value}
              }),
              examCenterId: values.examCenterId,
              venue: values.venue,
              vacancyApplicantStatusId: selectedSatusId,
              date: moment(values.date).format('YYYY-MM-DD'),
              time: moment(values?.time).format('HH:mm a'),
            }

            handleFormSubmit(payload)
          }}
        >
          {({isSubmitting, touched, handleChange, errors, values, setFieldValue}) => {
            return (
              <Form>
                <div className='card-body border-top pt-5'>
                  <div className='row'>
                    <div className='col-12  mb-2'>
                      <label className={`mb-2 fw-bolder fs-6 ${'col-md-12' || 'col-lg-4'}`}>
                        <span>{'Selected Candidate'}</span>
                      </label>
                      <Select
                        placeholder='Please select'
                        name='vacancyApplicantId'
                        defaultValue={selectedCandidate}
                        isMulti={true}
                        options={selectedCandidate}
                        isDisabled={true}
                      />
                    </div>
                    <div className='col-12'>
                      <FormTextBox
                        labelClassName='col-12'
                        containerClassName='col-md-12'
                        placeholder='Please add venue'
                        label='Interview Venue'
                        name='venue'
                        onChange={handleChange}
                        errors={errors}
                        touched={touched}
                        required
                      />
                    </div>
                    <div className='col-12'>
                      <FormDatepicker
                        labelClassName='col-12'
                        containerClassName='col-12 '
                        label=' Date'
                        name='date'
                        placeholderText='Please select a date'
                        setFieldValue={setFieldValue}
                        value={values.date || false}
                        touched={touched}
                        required={true}
                        showIcon={true}
                        errors={errors}
                        dateFormat='yyyy/MM/dd'
                        minDate={new Date()}
                      />
                    </div>
                    <div className='col-12'>
                      <FormDatepicker
                        labelClassName='col-12'
                        containerClassName='col-12 '
                        label='Time'
                        name='time'
                        placeholderText='Please select a time'
                        setFieldValue={setFieldValue}
                        value={values.time || false}
                        touched={touched}
                        required={true}
                        showIcon={true}
                        showTimeSelect={true}
                        showTimeSelectOnly={true}
                        errors={errors}
                        dateFormat='h:mm aa'
                      />
                    </div>
                  </div>
                </div>

                <div className='d-flex justify-content-end  '>
                  <button
                    type='submit'
                    disabled={loading}
                    data-cy='modal-submit'
                    className='btn btn-primary btn-sm ms-3'
                  >
                    Save
                  </button>
                </div>
              </Form>
            )
          }}
        </Formik>
      </Modal.Body>
    </Modal>
  )
}
